import { Button, Dialog, DialogActions, DialogContent, DialogTitle, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ConfirmButton from '../Button/ConfirmButton'

type ConfirmationDialogProps = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  handleClose?: () => void
  handleConfirm: () => void
  title: string
  content?: React.ReactNode
  loading?: boolean
  confirmationButtonText?: string
}

const ConfirmationDialog = ({
  open,
  setOpen,
  handleClose = () => setOpen(false),
  handleConfirm,
  title,
  content,
  loading,
  confirmationButtonText,
}: ConfirmationDialogProps) => {
  const { t } = useTranslation()

  const theme = useTheme()

  const paperStyle = {
    minWidth: theme.spacing(45),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  }

  return (
    <Dialog
      className={open ? 'vacation-dialog-open' : ''}
      onClose={handleClose}
      open={open}
      PaperProps={{
        style: paperStyle,
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions sx={{ gap: 2 }}>
        <Button size="small" onClick={() => setOpen(false)}>
          {t('components.dialog.return')}
        </Button>
        <ConfirmButton
          text={confirmationButtonText ?? t('components.dialog.confirm')}
          onClick={() => handleConfirm()}
          isLoadingButton={true}
          isLoading={loading}
          isDisabled={loading}
        />
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
